import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";

import { CompanyCreateForm as ACompanyCreateForm } from "ui-components/index";
import { customListCompaniesByNit } from "graphql/custom-queries";
import { API, graphqlOperation } from "aws-amplify";
import { listCompanies } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";
import { createManagedCompany } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const CompanyCreateForm = ({ onSuccess }) => {
  const { me, setMe } = useContext(LayoutContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onValidateNit = {
    nit: async (value, validationResponse) => {
      if (value) {
        const lastIndex = value.lastIndexOf("-");
        const resultValue =
          lastIndex !== -1 ? value.substring(0, lastIndex) : value;

        const companiesData = await API.graphql(
          graphqlOperation(customListCompaniesByNit, {
            filter: {
              nit: { contains: resultValue },
            },
          })
        );
        const companiesItems = companiesData.data.listCompanies.items ?? [];
        if (companiesItems.length > 0) {
          return {
            hasError: true,
            errorMessage: strings.validations.nit,
          };
        }
      }
      return validationResponse;
    },
  };

  async function fetchCompanyByNit(nit) {
    try {
      const companiesData = await API.graphql(
        graphqlOperation(listCompanies, {
          filter: { nit: { eq: nit } },
        })
      );
      return companiesData.data.listCompanies.items[0];
    } catch (err) {
      console.log(strings.responses.errorFetch, err);
      return null;
    }
  }

  async function createChild(parentID, childID) {
    try {
      await API.graphql({
        query: createManagedCompany.replaceAll("__typename", ""),
        variables: {
          input: {
            parentID,
            childID,
          },
        },
      });
    } catch (err) {
      console.log(strings.responses.errorCreate, err);
    }
  }

  const onSuccessForm = async (values) => {
    const { nit } = values;

    setLoading(true);

    if (me.companyID) {
      const company = await fetchCompanyByNit(nit);
      if (company?.id) {
        await createChild(me.companyID, company.id);
        setMe({
          ...me,
          managedCompanies: [...me.managedCompanies, company.id],
        });
      }
    }

    toast.success(strings.successAdded);
    setLoading(false);

    if (onSuccess) onSuccess();
    else navigate("/companies");
  };

  const onError = (_model, error) => toast.error(error);

  return (
    <div>
      <ACompanyCreateForm
        overrides={{
          name: {
            label: (
              <span>
                {strings.fields.name}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          nit: {
            label: (
              <span>
                {strings.fields.nit}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          abbreviation: {
            label: strings.fields.abbreviation,
          },
          address: {
            label: strings.fields.address,
          },
          phone: {
            label: strings.fields.phone,
          },
          country: {
            label: strings.fields.country,
          },
          city: {
            label: strings.fields.city,
          },
          description: {
            label: strings.fields.description,
          },
          legalRepName: {
            label: strings.fields.legalRepName,
          },
          legalRepContact: {
            label: strings.fields.legalRepContact,
          },
          otherContacts: {
            label: strings.fields.otherContacts,
          },
          ClearButton: {
            children: strings.clear,
          },
          SubmitButton: {
            children: strings.add,
          },
        }}
        onValidate={onValidateNit}
        onSuccess={onSuccessForm}
        onError={onError}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Empresa",
    clear: "Restablecer",
    add: "Agregar",
    successAdded: "Empresa agregada con éxito",
    fields: {
      name: "Nombre Empresa",
      nit: "Nit",
      abbreviation: "Abreviatura",
      address: "Dirección principal",
      phone: "Teléfono",
      country: "País",
      city: "Ciudad",
      description: "Descripción",
      legalRepName: "Nombre del Representante Legal",
      legalRepContact: "Contacto del Representante Legal",
      otherContacts: "Otros contactos",
    },
    validations: {
      nit: "El nit ingresado ya existe",
    },
    responses: {
      errorFetch: "Error al consultar la empresa",
      errorCreate: "Error al crear la empresa administrada",
    },
  },
});

export default CompanyCreateForm;
